module.exports = __webpack_public_path__ + "static/tcdd-sorunlar-385797840621e9cfe98484313d5f7b77.png";